module.exports = __webpack_public_path__ + "static/media/LogoSMSMIEMBRO.63a201df.png";